import type { TypeMeta } from '@/types/film';

export const categoryMeta: Record<string, TypeMeta> = {
  movie: {
    key: 'movie',
    label: '电影',
    path: '/category/movie',
    icon: 'ri-film-line',
    description: '精选院线新片与高分佳作，动作、悬疑、爱情、科幻多题材一站看全，按年份与地区轻松筛出你的下一部心头好。',
    genres: ['动作', '爱情', '科幻', '悬疑', '剧情', '喜剧', '动画', '犯罪'],
    accentNote: '共 260+ 部电影 · 每周四上新',
  },
  tv: {
    key: 'tv',
    label: '电视剧',
    path: '/category/tv',
    icon: 'ri-tv-2-line',
    description: '国产热播剧、海外高口碑剧集同步收录。追新剧不用等，按地区与年份快速定位，看到停不下来。',
    genres: ['都市', '古装', '悬疑', '战争', '家庭', '青春', '职场', '犯罪'],
    accentNote: '共 180+ 部剧集 · 每日更新',
  },
  variety: {
    key: 'variety',
    label: '综艺',
    path: '/category/variety',
    icon: 'ri-mic-line',
    description: '真人秀、音乐竞演、脱口秀与慢综艺合集，轻松解压的快乐源泉，周末躺平必备。',
    genres: ['真人秀', '音乐', '脱口秀', '生活', '竞技', '访谈'],
    accentNote: '共 90+ 档综艺 · 每周更新',
  },
};

export const categoryList: TypeMeta[] = [categoryMeta.movie, categoryMeta.tv, categoryMeta.variety];

export const typeLabel = (type: string): string => categoryMeta[type]?.label ?? '影视';

export const allRegions = ['中国大陆', '中国香港', '中国台湾', '美国', '英国', '日本', '韩国', '泰国'];